import { render, staticRenderFns } from "./PatientSafetyIndicatorsTable.vue?vue&type=template&id=119bcc52&"
import script from "./PatientSafetyIndicatorsTable.vue?vue&type=script&lang=js&"
export * from "./PatientSafetyIndicatorsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports